import React from "react";
import { Link } from "react-router-dom";

export const LinkTo = ({ to, children }: { to: string; children: React.ReactNode }) => {
  return (
    <Link target="blank" className="text-primary-500" to={to}>
      {children}
    </Link>
  );
};
